const ISO_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;

/**
 * Returns the first and last date of a WMS time extent.
 * Accepts the forms ADAGUC emits: "start/stop/period", a comma separated list of dates, or a comma separated
 * list of "start/stop/period" intervals. Throws when the extent is not in one of these forms.
 */
export const getTimeRange = (timeValues) => {
  const entries = timeValues.split(',');
  const firstEntry = entries[0].split('/');
  const lastEntry = entries[entries.length - 1].split('/');
  const beginDate = firstEntry[0];
  const endDate = lastEntry.length > 1 ? lastEntry[1] : lastEntry[0];
  if (!ISO_DATE_TIME.test(beginDate) || !ISO_DATE_TIME.test(endDate)) {
    throw new Error('Cannot determine time range from time extent: "' + timeValues + '"');
  }
  return { beginDate, endDate };
};

/**
 * ADAGUC advertises the time dimension with the units of the netCDF time variable (for example
 * "seconds since 1900-01-01 00:00") instead of "ISO8601". WMJSDimension only parses a "start/stop/period"
 * extent when the units are "ISO8601"; otherwise it parses the extent as numbers and ends up with zero values.
 * The extent itself is always ISO8601, so correct the units and parse the extent again.
 */
export const normaliseTimeDimensionUnits = (timeDimension) => {
  if (timeDimension.units === 'ISO8601') {
    return;
  }
  timeDimension.units = 'ISO8601';
  timeDimension.reInitializeValues(timeDimension.values);
};
